































































































































































































import Vue from "vue";
import HttpClientFactory from "../../../services/HttpClientFactory";
import HttpClient from "../../../services/HttpClient";
import { Table, TableColumn, Select, Option, Tag } from "element-ui";
import BasePagination from "../../../components/black_dashboard_pro/BasePagination.vue";
import ApiReceiver from "../../../types/receivers/api/ApiReceiver";
import PaginationStatus from "../../../types/pagination/PaginationStatus";
import swal from "sweetalert2";

export default Vue.extend({
  name: "latest-created-invoices-table",
  components: {
    //@ts-ignore
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tag.name]: Tag,
  },
  computed: {
    paginatedData(): ApiReceiver[] {
      const result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to(): number {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from(): number {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total(): number {
      return this.tableData.length;
    },
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      } as PaginationStatus,
      tableData: [] as ApiReceiver[],
    };
  },
  async created() {
    this.httpClient = HttpClientFactory.getInstance();
    await this.loadPageSize();
    this.getReceivers();
  },
  methods: {
    editReceiver(id: string) {
      this.$router.push("./" + id + "/edit");
    },
    getReceivers() {
      this.httpClient
        .get(process.env.VUE_APP_BACKEND_ENDPOINT + "/receivers/v1/view")
        .then((res: any) => {
          const apiReceiver: ApiReceiver[] = res.data;
          this.tableData = apiReceiver.filter(
            (receiver) => !receiver.deletedAt
          );
        })
        .catch((e: any) => {
          const error: any = {
            text: this.$t("receiver:error"),
            type: "error",
          };
          this.$notify(error);
        });
    },
    async deleteReceiver(id: number) {
      const result = await swal.fire({
        title: this.$t("receiver:view.swal.title"),
        text: this.$t("receiver:view.swal.sub_title"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText:
          "<span data-test='confirm-button-swal-yes'>" +
          this.$t("receiver:view.swal.yes") +
          "</span>",
        cancelButtonText:
          "<span data-test='cancel-button-swal-no'>" +
          this.$t("receiver:view.swal.no") +
          "</span>",
        customClass: {
          confirmButton: "btn btn-next btn-wd btn-primary",
          cancelButton: "btn btn-next btn-wd btn-danger",
        },
        buttonsStyling: false,
      });
      if (result.isDismissed) {
        return false;
      }
      if (result.isConfirmed) {
        try {
          const res = await this.httpClient.delete(
            process.env.VUE_APP_BACKEND_ENDPOINT + `/receivers/v1/${id}`
          );
          const success: any = {
            text: this.$t("receiver:deleted"),
            type: "success",
          };
          this.$notify(success);

          const responseDelete: ApiReceiver = res.data;

          const findReceiverIndex = this.tableData.findIndex(
            (element: any) => element.id === responseDelete.id
          );

          this.tableData.splice(findReceiverIndex, 1);
          this.getReceivers();
        } catch (e) {
          const errorCode = e.response.data.code;

          if (errorCode === "cannot_delete_receiver") {
            const warn: any = {
              text: this.$t("receiver:cannot_delete_receiver"),
              type: "warn",
            };
            this.$notify(warn);
            return;
          }
          const error: any = {
            text: this.$t("receiver:error"),
            type: "error",
          };
          this.$notify(error);
        }
      }
      return result;
    },
    async loadPageSize() {
      try {
        const response = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/settings/v1"
        );
        this.pagination.perPage = response.data.pageSize;
      } catch (e) {
        const error: any = {
          text: this.$t("receiver:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
  },
});
